module.exports = __webpack_public_path__ + "static/media/ma.e11a0692.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ma.svg
// module id = 182
// module chunks = 0